import UndoCommand from "./UndoCommand";

export default class Undoable {
    commands: UndoCommand[];
    name: string;
    constructor(commands: UndoCommand[], name: string) {
        this.commands = commands
        this.name = name
    }
}